import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormComponent } from './form/form.component';
import { FieldComponent } from './field/field.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ToolbarModule } from 'primeng/toolbar';
import { ToolbarItemComponent } from './toolbar-item/toolbar-item.component';
import { SimpleFieldComponent } from './simple-field/simple-field.component';



@NgModule({
  declarations: [
    FormComponent,
    FieldComponent,
    ToolbarComponent,
    ToolbarItemComponent,
    SimpleFieldComponent
  ],
  exports: [
    FormComponent,
    FieldComponent,
    ToolbarComponent,
    ToolbarItemComponent,
    SimpleFieldComponent
  ],
  imports: [
    CommonModule  ,
    ToolbarModule
  ]
})
export class FormLayoutModule { }
